// this.$store.state.usuario
import { serverTimestamp } from "firebase/firestore";

// CLASE USUARIO
export const usuario = class {
  constructor() {
    return {
      id: "",
      nombre: "",
      apellido: "",
      ocupacion: "",
      documento: {
        numero: 0,
        tipo: "",
      },
      foto: {
        nombre: "",
        url: "",
        tipo: "",
      },
      portada: {
        nombre: "",
        url: "",
        tipo: "",
      },
      fechaNacimiento: "",
      genero: "",
      correo: "",
      password: "",
      preferencias: {
        //estado: "En Línea", // ESTADO PARA DETECTAR ACTIVIDAD DEL USUARIO APP
        idEmpresaSeleccionada: "",
        terminosCondiciones: false,
        politicaPrivacidad: false,
        notificaciones: {
          correoInspecciones: true,
        },
      },
      telefono: 0,
      ubicacion: {
        pais: "",
        departamento: "",
        ciudad: "",
        coordenadas: {
          latitud: 0,
          longitud: 0,
        },
        direccion: {
          barrio: "",
          tipo: "",
          calle: "",
          numero: {
            campo1: 0,
            campo2: 0,
          },
          complemento: "",
        },
      },
      registro: {
        estado: "Creado",
        metodo: "",
        creacion: serverTimestamp(),
        actualizacion: serverTimestamp(),
      },
    };
  }
};
